<template>
  <div class="form-item">
    <label v-if="label">
      {{ label }}
    </label>
    <div v-if="$slots.label" class="form-item-label">
      <slot name="label" />
    </div>
    <div class="form-item-value">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";

.form-item {
  margin-bottom: 16px;
}

label, .form-item-label {
  font-size: $size-6;
  line-height: 1.23;
  font-weight: $weight-normal;
  color: $grey;
  letter-spacing: normal;
  margin-bottom: 4px;
  display: block;
}

.form-item-value {
  min-height: 22px;
  font-size: $size-4;
  line-height: 20px;
}

@media screen and (max-width: 478px) {
  .form-item {
    line-height: 1;
  }
}
</style>
